import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const EmailIcon = props => {
  return (
    <Svg
      width={20}
      height={16}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.804 4.353C.524 6.956.536 9.958.926 12.55a3.138 3.138 0 002.831 2.66l1.51.131c3.15.274 6.317.274 9.466 0l1.51-.131a3.138 3.138 0 002.831-2.66c.39-2.592.403-5.594.122-8.197a30.343 30.343 0 00-.122-.904A3.138 3.138 0 0016.243.79l-1.51-.13a54.647 54.647 0 00-9.465 0l-1.51.13A3.138 3.138 0 00.925 3.45c-.045.301-.086.602-.122.904zm4.594-2.2a53.147 53.147 0 019.205 0l1.51.131c.754.066 1.365.64 1.478 1.388l.034.234-5.561 3.09a4.25 4.25 0 01-4.128 0l-5.56-3.09.033-.234a1.638 1.638 0 011.478-1.388l1.51-.131zm12.41 3.367a29.099 29.099 0 01-.217 6.807 1.638 1.638 0 01-1.478 1.389l-1.51.131a53.152 53.152 0 01-9.205 0l-1.51-.131a1.638 1.638 0 01-1.479-1.389 29.101 29.101 0 01-.217-6.807l5.016 2.786a5.75 5.75 0 005.585 0l5.016-2.786z"
        fill="#001533"
      />
    </Svg>
  );
};

export default EmailIcon;
